import { render, staticRenderFns } from "./GotoStep.vue?vue&type=template&id=2fbd8e02&scoped=true"
import script from "./GotoStep.vue?vue&type=script&lang=js"
export * from "./GotoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd8e02",
  null
  
)

export default component.exports